// $resource 示例
export default function dateInterceptor() {
    'ngInject'

    // return $resource('/common/data/appInfo.json');
    return {
        getDateStr: (addDayCount) => { // 时间日期的换算
            const dd = new Date()
            dd.setDate(dd.getDate() + addDayCount)// 获取AddDayCount天后的日期
            const y = dd.getFullYear()
            const m = (dd.getMonth() + 1) < 10 ? `0${dd.getMonth() + 1}` : (dd.getMonth() + 1)// 获取当前月份的日期，不足10补0
            const d = dd.getDate() < 10 ? `0${dd.getDate()}` : dd.getDate()// 获取当前几号，不足10补0
            return `${y}-${m}-${d}`
        },
        // 获得两个日期之间相差的天数
        getDays(date1, date2) {
            date1 = date1.toString()
            date2 = date2.toString()
            const date1Str = date1.split('-')// 将日期字符串分隔为数组,数组元素分别为年.月.日
            // 根据年 . 月 . 日的值创建Date对象
            const date1Obj = new Date(date1Str[0], (date1Str[1] - 1), date1Str[2])
            const date2Str = date2.split('-')
            const date2Obj = new Date(date2Str[0], (date2Str[1] - 1), date2Str[2])
            const t1 = date1Obj.getTime()
            const t2 = date2Obj.getTime()
            const dateTime = 1000 * 60 * 60 * 24 // 每一天的毫秒数
            const minusDays = Math.floor(((t2 - t1) / dateTime))// 计算出两个日期的天数差
            const days = Math.abs(minusDays)// 取绝对值
            return days
        },
    }
}



// WEBPACK FOOTER //
// ./src/common/factory/dateInterceptor.js